<template>
  <div
    >
    <v-snackbar
      v-model="alert.active"
      right
      outlined
      color="info"
      :timeout="-1"
      >
      <div
        class="font-weight-medium d-flex align-center"
        style="gap: 12px"
        >
        <v-icon
          color="info"
          >
          mdi-information-outline
        </v-icon>

        <div>
          {{ alert.message }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="info"
          icon
          v-bind="attrs"
          @click="alert.active = false"
          >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <div 
      style="gap: 8px"
      class="d-flex flex-wrap white px-8 pt-4 align-center"
      >
      <h1 class="my-2 mb-4">Caja</h1>

      <v-spacer></v-spacer>

      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="dateRange"
        width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateRange"
            label="Período"
            prepend-inner-icon="mdi-calendar"
            style="max-width: 300px"
            class="rounded-lg"
            color="primary"
            readonly
            dense
            outlined
            hide-details
            v-bind="attrs"
            v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateRange"
          type="month"
          range
          scrollable
          >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
            >
            Cancelar
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(dateRange)"
            >
            Aceptar
          </v-btn>
        </v-date-picker>
      </v-dialog>

      <cash-register
        ></cash-register>
    </div>

    <v-container
      class="px-8"
      fluid
      >
      <main-balance
        :accounts="accounts"
        ></main-balance>

      <v-row>
        <template
          v-for="account in accounts"
          >
          <v-col
            cols="12"
            md="6"
            lg="4"
            >
            <account
              :account="account"
              :period="dateRange"
              @reload="fetchAccounts"
              ></account>
          </v-col>
        </template>

        <v-col
          cols="12"
          md="6"
          lg="4"
          >
          <account
            :account="advanced"
            ></account>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Accounts } from '@/graphql/queries/account'
import { Advanced } from '@/graphql/queries/payment'

import CashRegister from '@/components/balances/CashRegister'
import MainBalance from '@/components/balances/Main'
import Account from '@/components/balances/Account'

export default {
  data: () => ({
    alert: {
      active: false,
      message: 'Se desactivaron temporalmente los filtros para solucionar un problema de rendimiento.'
    },
    modal: false,
    count: 0,
    dateRange: [],
    accounts: [],
    advanced: {
      name: 'Resultado Adelantos',
      subAccounts: []
    }
  }),

  watch: {
    dateRange () {
      this.fetchAccounts()
    }
  },

  created () {
    this.fetchAccounts ()
    this.fetchConcepts ()
  },

  methods: {
    fetchAccounts () {
      this.$apollo.query({
        query: Accounts,
        variables: {
          period: this.dateRange
        },
        fetchPolicy: 'no-cache'
      }).then( res => {
        this.accounts = res.data.accounts
        this.count += 1
      })
    },

    fetchConcepts () {
      this.$apollo.query({
        query: Advanced,
        fetchPolicy: 'no-cache'
      }).then( res => {
        this.concepts = res.data.advanced
      })
    },
  },

  components: {
    MainBalance,
    Account,
    CashRegister,
  }
}
</script>
